import { render } from "./arrayYoutube.vue?vue&type=template&id=0c1a4a75&scoped=true"
import script from "./arrayYoutube.vue?vue&type=script&lang=js"
export * from "./arrayYoutube.vue?vue&type=script&lang=js"

import "./arrayYoutube.vue?vue&type=style&index=0&id=0c1a4a75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1a4a75"]])

export default __exports__